import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatabasesDisplayGridRowDataFragmentGql } from './DatabasesDisplayGridRowFragmentGql';

export const TableDownstreamDatabasesFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamDatabasesFilteredByColumnQuery(
  $tableId: ID!,
  $columnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DatabaseSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!
) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowDataFragment
        }
      }
      maxDownstreamDatasources: downstreamDatabasesConnection(
        orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection { totalCount }
        }
      }
      maxDownstreamWorkbooks: downstreamDatabasesConnection(
        orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection { totalCount }
        }
      }
    }
  }
}
${DatabasesDisplayGridRowDataFragmentGql}
`;
